<!--首购订单查看-->
<template>
  <div>
    <app-breadcrumb/>
    <div class="page-container view-orderquery">
      <el-form v-loading="listLoading" :model="viewObj" label-width="110px">
        <!--      基本信息-->
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <!--    订单编号  -->
        <el-form-item :label="$t('poOrder.orderNo')+':'">
          {{ viewObj.orderNo }}
        </el-form-item>
        <!--      会员编号-->
        <el-form-item :label="$t('poOrder.memberNo')+':'">
          {{ viewObj.memberNo }}
        </el-form-item>
        <!--      单据类型-->
        <el-form-item :label="$t('fiAcInput.orderType')+':'">
          {{ $lt('po.allordertype.cn', viewObj.orderType) }}
        </el-form-item>
        <!--      收货方式-->
        <el-form-item v-if="viewObj.companycode == 'IN'" :label="$t('PoOrder.recType')+':'">
          {{ $lt('poorder.rectype', viewObj.recType) }}
        </el-form-item>
        <!--      收货人姓名-->
        <el-form-item v-if="viewObj.companycode == 'IN'" :label="$t('PoOrder.recName')+':'">
          {{ viewObj.recName }}
        </el-form-item>
        <!--      联系电话-->
        <el-form-item v-if="viewObj.companycode == 'IN'" :label="$t('sysCompany.phone')+':'">
          {{ viewObj.recPhone }}
        </el-form-item>
        <!--      收货地址-->
        <el-form-item v-if="viewObj.companycode == 'IN'" :label="$t('ssCustomer.saddress')+':'">
          {{ viewObj.recAddr }}
        </el-form-item>
        <!--      邮编-->
        <el-form-item v-if="viewObj.companycode == 'IN'" :label="$t('poscore.zip')+':'">
          {{ viewObj.zipCode }}
        </el-form-item>
        <!--      创建时间-->
        <el-form-item :label="$t('pmProductSppm.createDate')+':'">
          {{ viewObj.createTime }}
        </el-form-item>
        <!--      审核时间-->
        <el-form-item :label="$t('pmProductSppm.checkDate')+':'">
          {{ viewObj.checkTime }}
        </el-form-item>
        <!--      状态-->
        <el-form-item :label="$t('pmProductList.status')+':'">
          {{ $lt(this.initDict.status, viewObj.status) }}
        </el-form-item>
        <!--      付款方式-->
        <h3 style="color: #b3640d">{{ $t('fiPayAdvice.dealType') }}</h3>
        <!--      商品总金额-->
        <el-form-item :label="$t('poAssistMemberOrder.productAmount')+':'">
          {{ viewObj.totalAmount }}
        </el-form-item>
        <!--      PV-->
        <el-form-item :label="$t('PV')+':'">
          {{ viewObj.totalFv }}
        </el-form-item>
        <el-form-item v-if="(viewObj.orderType == 27 || viewObj.orderType ==35)&& this.companyCode!=='BD'"
                      :label="$t('BiGoods.proPv')+':'">
          {{ viewObj.totalpointA0 }}
        </el-form-item>
        <!--      物流费-->
        <el-form-item :label="$t('poOrder.mailFee')+':'">
          {{ viewObj.sendFee }}
        </el-form-item>
        <el-form-item v-if="viewObj.paymentMethod == 14" :label="$t('fi.type.ac.e')">
          {{ viewObj.totalAmount - viewObj.totalFc }}
        </el-form-item>
        <el-form-item v-if="viewObj.paymentMethod == 14" :label="$t('fi.type.ac.send')">
          {{ viewObj.totalFc }}
        </el-form-item>
        <!--      合计-->
        <el-form-item v-if="viewObj.paymentMethod != 14" :label="$t('bdSendEfuboBonusDetail.amtCount')+':'">
          {{ viewObj.totalAmount + viewObj.sendFee }}
        </el-form-item>
        <!--      孟加拉分单信息显示-->
        <el-form-item v-if="poOrderSubList.length>1">
          <el-table :data="poOrderSubList" border fit show-summary style="width:100%;margin: 10px 0 20px 0;">
            <el-table-column :label="$t('miMember.memberNo')" align="center" prop="memberNo"/>
            <el-table-column :label="$t('Account.money')" align="center" prop="standardPrice"/>
            <el-table-column align="center" label="pv" prop="standardPv"/>
          </el-table>
        </el-form-item>
        <el-form-item
            v-if="((viewObj.paymentMethod) != 14 && (viewObj.orderType == 27||viewObj.orderType ==35)&& this.companyCode!=='BD')"
            :label="$t('bvPointChange.updatePoint')">
          {{ viewObj.totalpointA0 }}
        </el-form-item>
        <!--      付款方式-->
        <el-form-item :label="$t('fiPayAdvice.dealType')+':'">
          {{ $lt(this.initDict.payment, viewObj.paymentMethod) }}
        </el-form-item>
        <!--      商品清单-->
        <h3 style="color: #b3640d">{{ $t('busi.goods.list') }}</h3>
        <el-table
            :key="tableKey"
            :data="list"
            border
            fit
            highlight-current-row
            size="mini"
            style="width: 100%;"
        >
          <!--     商品编码(旧) -->
          <el-table-column :label="$t('Old_goodsCode')" prop="oldcode" align="center" />
          <!--    商品编号  -->
          <el-table-column :label="$t('pmProductList.productId')" align="center" prop="goodsCode"/>
          <!--      商品名称-->
          <el-table-column :label="$t('stStock.goodsname')" align="center" prop="goodsName">
            <template v-slot="{row}">
              <div v-if="row.isThird || row.isThird == '0'">
                {{ row.name }}
              </div>
            </template>
          </el-table-column>
          <!--      进号单价-->
          <el-table-column :label="$t('po.field.price')" align="center" prop="f$"/>
          <!--      订购数量-->
          <el-table-column :label="$t('poOrder.count')" align="center" prop="quantity"/>
          <!--      单品总金额-->
          <el-table-column :label="$t('bigoods.pergoods.total')" align="center" prop="">
            <template v-slot="{row}">
              {{ row.f$ * row.quantity }}
            </template>
          </el-table-column>
          <!--      是否赠品-->
          <el-table-column :label="$t('bigoods.send.ornot')" align="center" prop="">
            <template v-slot="{row}">
              <div v-if="row.isGive == 1">{{ $t('yesno.yes') }}</div>
              <div v-else>{{ $t('yesno.no') }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
          <el-button icon="el-icon-close" size="mini" type="warning" @click="$router.back(-1)">
            {{ $t('operation.button.cancel') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {orderView} from "@/api/ay-business-manager/orderquery";
import {mapGetters} from "vuex";

export default {
  name: "ViewOrderquery",
  data() {
    return {
      viewObj: {},
      tableKey: 0,
      listLoading: false,
      list: [],
      poOrderSubList: [], //孟加拉分单信息
      viewTd: null,
      initDict: {
        status: 'po.order.status',
        payment: 'po.order.payment.cn',
      }
    }
  },
  created() {
    this.getView(this.$route.params.id)
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
  },
  methods: {
    getView(val) {
      this.listLoading = true
      orderView({'id': val}).then(res => {
        this.viewObj = res.data
        this.poOrderSubList = res.data.poOrderSubList
        this.list = res.data.poOrderDetails
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
        this.$router.back(-1)
        console.error(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
